iziToast.settings({
    timeout: 5000,
    resetOnHover: true,
    position: 'topRight',
});
console.log(trans.loading);
$(document).ready(function () {
    var select_city = 'Select City';
    var select_country = 'Select country';
    var maxCount31 = 'Max Count 31';
    if (lang == 'ar') {
        select_city = 'اختر المدينة';
        select_country = 'اختر الدولة'; 
        var maxCount31 = 'العدد الاكبر هوا 31';
    } if (lang == 'fr') {
        trans.loading = 'Chargement en cours';
        select_city = 'اختر المدينة';
        select_country = 'اختر الدولة';
    }

    var _rtl = $('body').hasClass('rtl') ? true : false;



    // Testimonials Cards Carousel
    const testimonialsCards = new Swiper('.testimonialsCards', {
        slidesPerView: "auto",
        spaceBetween: 20,
        breakpoints: {
            0: {
                spaceBetween: 12,
            },
            992: {
                spaceBetween: 20,
            }
        },
        pagination: {
            el: ".swiper-pagination",
            type: 'bullets',
            clickable: true,
        },
    });

    // reels Carousel

    $('.reelsCarousel').append('<div class="swiper-pagination"></div>');
    const reelsCarousel = new Swiper('.reelsCarousel', {
        slidesPerView: "auto",
        spaceBetween: 20,
        breakpoints: {
            0: {
                spaceBetween: 12,
            },
            992: {
                spaceBetween: 20,
            }
        },
        pagination: {
            el: '.swiper-dynamic-pagination',
            clickable: true,
            dynamicBullets: true,
        },
    })

    // reels Carousel

    $('.tags').append('<div class="swiper-pagination"></div>');
    const tags = new Swiper('.tags', {
        slidesPerView: "auto",
        spaceBetween: 10,
        pagination: {
            el: '.swiper-dynamic-pagination',
            clickable: true,
            dynamicBullets: true,
        },
    })
    var gallerySlide = document.querySelectorAll('.trip-gallery .swiper-slide');
    const tripGallery = new Swiper('.trip-gallery', {
        slidesPerView: 1,
        spaceBetween: 20,
        allowTouchMove: gallerySlide.length <= 1 ? false : true,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        pagination: {
            el: '.slides-count',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
                return `${total} / ${current}`;
            }
        },
    })

    //add read more to .inner-content to switch max-height to auto 
    if ($('.overview-inner-content').height() >= 285) {
        $('.readMore').on('click', function () {
            $('.overview-inner-content').toggleClass('show-more')
            $('.readMore').toggleClass('show-more')
        })
    } else {
        $('.readMore').css('display', 'none')
        $('.readLess').css('display', 'none')
    }
    $('.show-more-days').on('click', function () {
        $(this).toggleClass('show');
        $('.program-day.other-days').toggleClass('show');
        var resizeEvent = window.document.createEvent('UIEvents');
        resizeEvent.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(resizeEvent);
    })
    $(document).ready(function () {
        // Update the displayed value for all counters
        function updateCounterDisplay(counter) {
            var counterValue = $(counter).find(".counter-display");
            var value = parseInt($(counterValue).val(), 10);
            $(counterValue).val(value);
        }

        // Event handler for the plus button
        $(".counter-plus").click(function () {
            var counter = $(this).closest('.counter');
            var counterValue = $(counter).find(".counter-display");
            var value = parseInt($(counterValue).val(), 10);
            $(counterValue).val(value + 1);
            counterValue.trigger('change');
        });

        // Event handler for the minus button
        $(".counter-minus").click(function () {
            var counter = $(this).closest('.counter');
            var counterValue = $(counter).find(".counter-display");
            var value = parseInt($(counterValue).val(), 10);
            if (value > 1) {
                $(counterValue).val(value - 1);
            }
            counterValue.trigger('change');
        });
        $(".counter-display").on('change', function () {
            $(this).val() < 1 ? $(this).val('1') : $(this).val();
            var counter = $(this).closest('.counter');
            if ($(this).val() >= 31) {
                $(counter).find(".counter-plus").attr('disabled', 'disabled');
                $(this).val(31);
            } else {
                $(counter).find(".counter-plus").removeAttr('disabled');
            }
            var price = $(this).closest('.payment-card').find(".price");
            price.text(" $ " + parseInt(price.data('price') * parseInt($(this).val())));
        })
    });
}); 